import { onUnmounted, ref, watch } from "vue";

/**
 * Creates a reactive value that automatically resets
 * to default after a timeout has elapsed.
 */

// eslint-disable-next-line import/prefer-default-export
export function useTransientValue<T>(defaultValue: T, initialTimeout = 5000) {
  const theValue = ref<T>(defaultValue);
  const currentTimeout = ref(initialTimeout);
  let timer: number | null = null;

  watch(theValue, (newValue) => {
    if (newValue !== defaultValue) {
      clear();

      timer = window.setTimeout(() => {
        theValue.value = defaultValue;
        currentTimeout.value = initialTimeout;
      }, currentTimeout.value);
    }
  });

  function setValue(newValue: T) {
    theValue.value = newValue;
    clear();
    setTimeout(currentTimeout.value);
  }

  function setTimeout(newTimeout: number) {
    currentTimeout.value = newTimeout;

    if (theValue.value !== defaultValue) {
      clear();

      timer = window.setTimeout(() => {
        theValue.value = defaultValue;
        currentTimeout.value = initialTimeout;
      }, currentTimeout.value);
    }
  }

  function clear(): void {
    if (timer !== null) clearTimeout(timer);
  }

  onUnmounted(() => {
    clear();
  });

  return {
    value: theValue,
    setValue,
    setTimeout,
  };
}
